<template>

    <div class="group _area">

        <h2 class="heading_line _jp _alpha-down">
            <p><span>エリアで検索</span></p>
            <div class="line"></div>
        </h2>

        <div class="item-wrap _small">

            <div class="item form_checkbox _lv1 _all" v-for="(area_region,index) in $store.state.search.set.areas" v-bind:key="index">
                <input type="checkbox" name="particular-area-lv1" class="" :id="'particular-area' + (index + 1)" v-on:change="changeAreaRegion(area_region)">
                <label :for="'particular-area' + (index + 1)" class="_highlight">
                    <div class="check-mark"><span></span></div>
                    <span>{{ area_region.name }}</span>
                </label>

                <!--lv2-->
                <div class="lv2-row">
                    <div class=" form_checkbox-wrap _small">

                        <div class="item form_checkbox _all" v-for="(area_prefecture, prefecture_index) in area_region.area_prefectures" v-bind:key="prefecture_index">
                            <input type="checkbox" :name="'particular-area-kyushu-lv2' + (area_prefecture.area_region_id)" class="" :id="'particular-area-' + (area_region.id) + '-lv2-' + ( prefecture_index + 1)" v-on:change="changeAreaPrefecture(area_prefecture)">
                            <label :for="'particular-area-' + (area_region.id) + '-lv2-' + ( prefecture_index + 1)" class="_highlight">
                                <div class="check-mark"><span></span></div>
                                <span>{{ area_prefecture.name }}</span>
                            </label>
                            <!--lv3-->
                            <div class="lv3-row">
                                <div class="form_checkbox-wrap _small">

                                    <div class="item form_checkbox" v-for="(area_city,city_index) in area_prefecture.area_cities" :key="city_index">
                                        <input type="checkbox" :name="'particular-area-kyushu-lv3' + (area_city.area_prefecture_id)" :id="'particular-' + (area_city.id) + '-lv3-' + (city_index + 1)" v-on:change="changeAreaCity(area_city)">
                                        <label :for="'particular-' + (area_city.id) + '-lv3-' + (city_index + 1)">
                                            <div class="check-mark"><span></span></div>
                                            <span>{{ area_city.name }}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div><!--/地方-->

        </div><!--/.item-wrap-->

    </div><!--/セールス募集-->

</template>

<script>
    export default {
        methods: {
            changeAreaRegion(area_region) {
                var id = area_region.id;
                var name = 'input[name=particular-area-kyushu-lv2' + id +']';

                $(name).prop('checked', false);

                // 地方のチェックが外れた時にVuexの市データを削除
                this.$store.state.search.form.areaLv3

                var area_prefectures = this.$store.state.search.form.areaLv2;
                var result = area_prefectures.filter((area_prefecture) => {
                    return (area_prefecture.area_region_id == area_region.id);
                });
                var area_prefecture_id = '';
                result.forEach(function(item, index){
                    area_prefecture_id = item.id;
                });

                var area_cities = this.$store.state.search.form.areaLv3;
                var city = area_cities.filter((area_city) => {
                    return (area_city.area_prefecture_id !== area_prefecture_id);
                });

                this.$store.state.search.form.areaLv3 = city;

                 // 地方のチェックが外れた時にVuexの県データも削除
                var area_prefectures = this.$store.state.search.form.areaLv2;
                var result = area_prefectures.filter((area_prefecture) => {
                    return (area_prefecture.area_region_id !== area_region.id);
                });
                this.$store.state.search.form.areaLv2 = result;
            },
            changeAreaPrefecture(area_prefecture) {
                var id = area_prefecture.id;
                var name = 'input[name=particular-area-kyushu-lv3' + id +']';
                $(name).prop('checked', false);

                // 検索用の県のデータをVuex格納
                var itemIndex = '';
                var itemCheck = true;

                this.$store.state.search.form.areaLv2.forEach(function(item, index){
                    if (item.name == area_prefecture.name) {
                        itemIndex = index;
                        itemCheck = false;
                    }
                }); 

                if (!itemCheck){
                    this.$store.state.search.form.areaLv2.splice(itemIndex, 1)
                } else {
                    this.$store.state.search.form.areaLv2.push(area_prefecture)
                }

                // 県のチェックが外れた時にVuexの市データを削除
                var area_cities = this.$store.state.search.form.areaLv3;
                var result = area_cities.filter((area_city) => {
                    return (area_city.area_prefecture_id !== area_prefecture.id);
                });

                this.$store.state.search.form.areaLv3 = result;
            },
            changeAreaCity(area_city) {
                var itemIndex = '';
                var itemCheck = true;

                this.$store.state.search.form.areaLv3.forEach(function(item, index){
                    if (item.name == area_city.name) {
                        itemIndex = index;
                        itemCheck = false;
                    }
                }); 

                if (!itemCheck){
                    this.$store.state.search.form.areaLv3.splice(itemIndex, 1)
                } else {
                    this.$store.state.search.form.areaLv3.push(area_city)
                }
            },
        }
    }
</script>
